import React, { Component } from "react";
import DatePicker from "react-datetime";
import moment from "moment";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "jspdf-autotable";
import {
  main_url,
  getMainRole,
  getUserId,
  getFirstDayOfMonth,
  getFirstDayOfNextMonth,
  getFirstDayOfNextTwoMonth,
} from "../../utils/CommonFunction";
import Select from "react-select";
import { getHeaders } from "../../utils/apiHelper";
const $ = require("jquery");
const jzip = require("jzip");
window.JSZip = jzip;
$.DataTable = require("datatables.net-bs4");
$.DataTable = require("datatables.net-responsive-bs4");
$.DataTable = require("datatables.net");
require("datatables.net-buttons/js/dataTables.buttons.min");
require("datatables.net-buttons/js/buttons.html5.min");

export default class LeaveManagementTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: props.tab,
      user_id: getUserId("user_info"),
      data: [],
      is_main_role: getMainRole(),
      year: moment(getFirstDayOfMonth()),
      start_date: moment(getFirstDayOfMonth()),
      end_date: moment(new Date()),
      loading: false,
      statusList: [
        { label: "All", value: 0 },
        { label: "Request", value: 1 },
        { label: "Verify", value: 2 },
        { label: "Approve", value: 3 },
        { label: "Reject", value: 4 },
        { label: "ReferBack", value: 5 },
        { label: "Cancel Request", value: 6 },
        { label: "Cancel Verify", value: 7 },
        { label: "Cancel Approve", value: 8 },
        { label: "Cancel Reject", value: 9 },
      ],
      leaveCategory: [],

      selected_category: { label: "All", value: 0 }, // Modify by STHA
      selected_category_value: null,

      selected_status: { label: "All", value: 0 }, // Modify by STHA
      selected_status_value: null,

      selected_position: { label: "All", value: 0 }, // Added by STHA
      selected_position_value: null, // Added by STHA

      selected_department: { label: "All", value: 0 }, // Added by STHA
      selected_department_value: null, // Added by STHA

      selected_branch: { label: "All", value: 0 }, // Added by STHA
      selected_branch_value: null, // Added by STHA

      selected_region: { label: "All", value: 0 }, // Added by STHA
      selected_region_value: null, // Added by STHA

      LeaveDatePermission: null,
      // NextDate: moment(getFirstDayOfNextMonth()), // Comment By STHA
      NextDate: moment(getFirstDayOfNextTwoMonth()),
      // isHR: this.props.isHR

      designationList: null,
      branchlist: null,
      departmentlist: null,
      regionList: null,
    };
  }

  getData() {
    let tab = this.state.tab;
    // let year = moment(this.state.year).format("YYYY"); // Modify By STHA
    let year = moment(this.state.start_date).format("YYYY");

    if (tab === 0) {
      this.getMyLeave(year);
    } else if (tab === 2) {
      let selectedStatusValue = this.state.selected_status_value
        ? this.state.selected_status_value
        : 0;
      let selectedCategoryValue = this.state.selected_category_value
        ? this.state.selected_category_value
        : 0;

      // Added Start by STHA for new CRN
      let selectedPosition = this.state.selected_position_value
        ? this.state.selected_position_value
        : 0;
      let selectedDepartment = this.state.selected_department_value
        ? this.state.selected_department_value
        : 0;
      let selectedRegion = this.state.selected_region_value
        ? this.state.selected_region_value
        : 0;
      let selectedBranch = this.state.selected_branch_value
        ? this.state.selected_branch_value
        : 0;
      // Added end by STHA for new CRN

      this.setState({ loading: true });

      this.getAllLeave(
        year,
        selectedCategoryValue,
        selectedStatusValue,
        selectedPosition,
        selectedDepartment,
        selectedRegion,
        selectedBranch
      );
    }
  }

  componentDidMount() {
    this.$el = $(this.el);

    this.getDesignationList(); // Added by STHA
    this.getBranchList(); // Added by STHA
    this.getDepartmentList(); // Added by STHA
    this.getRegionList(); // Added by STHA

    this.getData();
    this.leaveCategory();
    this.setTableAction();
  }

  // Added By STHA to set Table Action Commonly
  setTableAction() {
    console.log(" _______________ in set table action _________________ ");
    this.$el = $(this.el);
    let that = this;
    $("#dataTables-table").on("click", "#toView", function () {
      var data = $(this).find("#view").text();
      data = $.parseJSON(data);
      that.props.goToViewForm(data);
    });

    $("#dataTables-table").on("click", "#toEdit", function () {
      var data = $(this).find("#edit").text();
      data = $.parseJSON(data);
      that.props.goToEditForm(data);
    });

    $("#dataTables-table").on("click", "#toCancel", function () {
      var data = $(this).find("#cancel").text();
      data = $.parseJSON(data);
      that.props.goToCancelForm(data);
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tab != this.props.tab) {
      this.setState(
        {
          tab: this.props.tab,
        },
        () => this.getData()
      );
    }
    this.setTableAction();
  }

  // Added start by STHA for New CRN
  getDesignationList() {
    fetch(`${main_url}main/getDesignations`, {
      headers: getHeaders(),
    })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        let lists = list.unshift({ value: 0, label: "All" });
        this.setState({
          designationList: list, //list.map(v => ({ ...v, label: v.region_name, value: v.region_id }))
        });
      });
  }

  getBranchList() {
    fetch(`${main_url}benefit/getBranchList`, {
            headers: getHeaders(),
        })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        let lists = list.unshift({ value: 0, label: "All" });
        this.setState({
          branchlist: list.map((v) => ({ ...v })),
        });
      });
  }

  getDepartmentList() {
    fetch(`${main_url}benefit/getDepartmentList`, {
            headers: getHeaders(),
        })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        let lists = list.unshift({ departments_id: 0, deptname: "All" });
        this.setState({
          departmentlist: list.map((v) => ({
            ...v,
            label: v.deptname,
            value: v.departments_id,
          })),
        });
      });
  }

  getRegionList() {
    fetch(`${main_url}benefit/getRegionList`, {
            headers: getHeaders(),
        })
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        let lists = list.unshift({ state_id: 0, state_name: "All" });
        this.setState({
          regionList: list.map((v) => ({
            ...v,
            label: v.state_name,
            value: v.state_id,
          })),
        });
      });
  }
  // Added end by STHA for New CRN

  leaveCategory() {
    fetch(main_url + "leave/getLeaveCategory", {
      headers: getHeaders(),
  })
      .then((response) => {
        if (response.ok) return response.json();
      })
      .then((res) => {
        res.unshift({ label: "All", value: 0 });
        this.setState({ leaveCategory: res });
      })
      .catch((error) => console.error(`Fetch Error =\n`, error));
  }
  getMyLeave() {
    fetch(`${main_url}leave/getMyLeave/${this.state.user_id}`, {
      headers: getHeaders(),
    })
      .then((response) => {
        if (response.ok) return response.json();
      })
      .then((res) => {
        this.setState({ data: res }, () => this._setTableData(res));
      })
      .catch((error) => console.error(`Fetch Error =\n`, error));
  }

  getAllLeave(
    year,
    selectedCategoryValue,
    selectedStatusValue,
    selectedPosition,
    selectedDepartment,
    selectedRegion,
    selectedBranch
  ) {
    console.log(
      "Here is Selected Category Value >>>>>>>>>>>>>>>>>>>>>",
      selectedCategoryValue
    );
    console.log(
      "Here is Selected Status Value >>>>>>>>>>>>>>>>>>>>>",
      selectedStatusValue
    );
    console.log(
      "Here is Selected Position Value >>>>>>>>>>>>>>>>>>>>>",
      selectedPosition
    );
    console.log(
      "Here is Selected Department Value >>>>>>>>>>>>>>>>>>>>>",
      selectedDepartment
    );
    console.log(
      "Here is Selected Branch Value >>>>>>>>>>>>>>>>>>>>>",
      selectedBranch
    );
    console.log(
      "Here is Selected Region Value >>>>>>>>>>>>>>>>>>>>>",
      selectedRegion
    );

    // console.log();

    // let years = moment(year).format("YYYY"); // comment by STHA
    let years = moment(this.state.start_date).format("YYYY");
    let startDate = moment(this.state.start_date).format("YYYY-MM-DD");
    let endDate = moment(this.state.end_date).format("YYYY-MM-DD");

    this.setState({ loading: true });
    fetch(
      `${main_url}leave/getAllLeave/${years}/${this.state.user_id}/${startDate}/${endDate}`, {
        headers: getHeaders(),
      }
    )
      .then((response) => {
        if (response.ok) return response.json();
      })
      .then((res) => {
        this.setState(
          { data: res, loading: false },
          () => {
            let tempData = res;
            if (selectedStatusValue !== 0) {
              console.log("1. Status Condition");
              tempData = tempData.filter(
                (d) => d.application_status == selectedStatusValue
              );
            }
            if (selectedCategoryValue !== 0) {
              console.log("2. Category Condition");
              tempData = tempData.filter(
                (d) => d.leave_category_id == selectedCategoryValue
              );
            }
            if (selectedPosition !== 0) {
              //designations_id
              console.log("3. Position Condition");
              tempData = tempData.filter(
                (d) => d.designations_id == selectedPosition
              );
            }
            if (selectedDepartment !== 0) {
              //departments_id
              console.log("4. Department Condition");
              tempData = tempData.filter(
                (d) => d.departments_id == selectedDepartment
              );
            }
            if (selectedBranch !== 0) {
              //location_master_id
              console.log("5. Branch Condition");
              tempData = tempData.filter(
                (d) => d.location_master_id == selectedBranch
              );
            }
            if (selectedRegion !== 0) {
              //state_id
              console.log("6. Region Condition");
              tempData = tempData.filter((d) => d.state_id == selectedRegion);
            }

            this._setTableData(tempData);
          }
          // selectedCategoryValue == 0 && selectedStatusValue == 0
          //   ? this._setTableData(res)
          //   : selectedCategoryValue != 0 && selectedStatusValue == 0
          //   ? this._setTableData(
          //       res.filter((d) => d.leave_category_id == selectedCategoryValue)
          //     )
          //   : selectedCategoryValue == 0 && selectedStatusValue != 0
          //   ? this._setTableData(
          //       res.filter((d) => d.application_status == selectedStatusValue)
          //     )
          //   : this._setTableData(
          //       res.filter(
          //         (d) =>
          //           d.application_status == selectedStatusValue &&
          //           d.leave_category_id == selectedCategoryValue
          //       )
          //     )
        );
        // this.setTableAction();
        // this.setState({ data: res, loading: false }, () => (selectedCategoryValue == 0 || selectedCategoryValue == null && selectedStatusValue == 0 || selectedStatusValue == null) ? this._setTableData(res) : (selectedCategoryValue != 0 || selectedCategoryValue != null && selectedStatusValue == 0 || selectedStatusValue == null) ? this._setTableData(res.filter(d =>  d.leave_category_id == selectedCategoryValue)) : (selectedStatusValue != 0 || selectedStatusValue != null && selectedCategoryValue != 0 || selectedCategoryValue != null ) ? this._setTableData(res.filter(d => d.application_status == selectedStatusValue && d.leave_category_id == selectedCategoryValue)) :  this._setTableData(res.filter(d =>  d.application_status == selectedStatusValue && d.leave_category_id == selectedCategoryValue)))
      })
      .catch((error) => console.error(`Fetch Error =\n`, error));
  }

  handlestatus = (event) => {
    this.setState({
      selected_status: event,
      selected_status_value: event.value,
    });
  };

  handlecategory = (event) => {
    this.setState({
      selected_category: event,
      selected_category_value: event.value,
    });
  };

  // Added start by STHA for new CRN
  handlePosition = (event) => {
    this.setState({
      selected_position: event,
      selected_position_value: event.value,
    });
  };

  handleDepartment = (event) => {
    this.setState({
      selected_department: event,
      selected_department_value: event.value,
    });
  };

  handleBranch = (event) => {
    this.setState({
      selected_branch: event,
      selected_branch_value: event.value,
    });
  };

  handleRegion = (event) => {
    this.setState({
      selected_region: event,
      selected_region_value: event.value,
    });
  };
  // Added end by STHA for new CRN

  handleAllLeave = () => {
    // let year = moment(this.state.year).format("YYYY");
    let year = moment(this.state.start_date).format("YYYY");

    let selectedStatusValue = this.state.selected_status_value
      ? this.state.selected_status_value
      : 0;
    let selectedCategoryValue = this.state.selected_category_value
      ? this.state.selected_category_value
      : 0;

    // Added start by STHA for new CRN
    let selectedPosition = this.state.selected_position_value
      ? this.state.selected_position_value
      : 0;
    let selectedDepartment = this.state.selected_department_value
      ? this.state.selected_department_value
      : 0;
    let selectedRegion = this.state.selected_region_value
      ? this.state.selected_region_value
      : 0;
    let selectedBranch = this.state.selected_branch_value
      ? this.state.selected_branch_value
      : 0;
    // Added end by STHA for new CRN

    this.getAllLeave(
      year,
      selectedCategoryValue,
      selectedStatusValue,
      selectedPosition,
      selectedDepartment,
      selectedRegion,
      selectedBranch
    );
  };
  handleMyLeave = () => {
    let year = moment(this.state.year).format("YYYY");
    this.getMyLeave();
  };
  // filter() {
  //     console.log("tab===>",this.state.tab)
  //     if (this.state.tab == 2) {

  //     } else if (this.state.tab == 0) {

  //     }
  // }

  handleYear = (event) => {
    this.setState({
      year: event,
    });
  };
  handleStartDate = (event) => {
    this.setState({
      start_date: event,
    });
  };
  handleEndDate = (event) => {
    this.setState({
      end_date: event,
    });
  };
  // addMonths(numOfMonths, date = new Date(end)) {
  //     date.setMonth(date.getMonth() + numOfMonths);

  //     return date;
  //   }

  _setTableData = (data) => {
    var table;
    // var permission = this.props.permission;
    // var has_action = permission.isView === 1 || permission.isEdit === 1 ? true : false;
    var has_action = true;

    var l = [];
    for (var i = 0; i < data.length; i++) {
      let result = data[i];
      let application_status = "";
      let reject_status = "";
      let obj = [];

      // application_status
      if (result.application_status === 0) {
        application_status =
          '<small class="label label-warning" style="background-color:#509aed"> Request </small>';
      } else if (result.application_status === 1) {
        application_status =
          '<small class="label label-warning" style="background-color:#509aed"> Request </small>';
      } else if (result.application_status === 2) {
        application_status =
          '<small class="label label-warning" style="background-color:#f2a509"> Verify  </small>';
      } else if (result.application_status === 3) {
        application_status =
          '<small class="label label-warning" style="background-color:#29a50a"> Approve  </small>';
      } else if (result.application_status === 4) {
        application_status =
          '<small class="label label-warning" style="background-color:#f60e2f"> Reject  </small>';
      } else if (result.application_status === 5) {
        application_status =
          '<small class="label label-warning" style="background-color:#cc0066"> Refer Back  </small>';
      } else {
        if (result.previous_status == 3) {
          application_status =
            '<small class="label label-warning" style="background-color:#29a50a"> Approve  </small>';
        } else if (result.previous_status == 5) {
          application_status =
            '<small class="label label-warning" style="background-color:#cc0066"> Refer Back  </small>';
        } else if (result.previous_status == 2) {
          application_status =
            '<small class="label label-warning" style="background-color:#f2a509"> Verify  </small>';
        } else if (result.previous_status == 1) {
          application_status =
            '<small class="label label-warning" style="background-color:#509aed"> Request </small>';
        } else {
          application_status =
            '<small class="label label-warning" style="background-color:#f60e2f"> Reject  </small>';
        }
      }

      // reject_status
      if (result.application_status === 6) {
        reject_status =
          '<small class="label label-warning" style="background-color:#eb6b1c"> Cancel Request </small>';
      } else if (result.application_status === 7) {
        reject_status =
          '<small class="label label-warning" style="background-color:#eb6b1c"> Cancel Verify</small>';
      } else if (result.application_status === 8) {
        reject_status =
          '<small class="label label-warning" style="background-color:#eb6b1c"> Cancel Approve</small>';
      } else if (result.application_status === 9) {
        reject_status =
          '<small class="label label-warning" style="background-color:#eb6b1c"> Cancel Reject</small>';
      } else {
        if (result.cancel_reject) {
          reject_status =
            '<small class="label label-warning" style="background-color:#eb6b1c"> Cancel Reject</small>';
        } else if (result.cancel_approve != null) {
          reject_status =
            '<small class="label label-warning" style="background-color:#eb6b1c"> Cancel Approve</small>';
        } else if (result.cancel_verify != null) {
          reject_status =
            '<small class="label label-warning" style="background-color:#eb6b1c"> Cancel Verify</small>';
        } else if (result.leave_cancel_apply_date != null) {
          reject_status =
            '<small class="label label-warning" style="background-color:#eb6b1c"> Cancel Request </small>';
        }
      }

      if (this.state.tab == 2) {
        obj = {
          no: i + 1,
          name: result.fullname,
          employee_id: result.employment_id,
          designations: result.designations, //Added by STHA
          deptname: result.deptname, //Added by STHA
          location_master_name: result.location_master_name, //Added by STHA
          state_name: result.state_name, //Added by STHA
          start_date: result.leave_start_date,
          end_date: result.leave_end_date,
          leave_day: result.leave_days,
          leave_category: result.leave_category,
          application_status: application_status,
          reject_status: reject_status,
          reason: result.reason, // added by STHA
          comment: result.comments,
        };
      } else {
        obj = {
          no: i + 1,
          name: result.fullname,
          employee_id: result.employment_id,
          start_date: result.leave_start_date,
          end_date: result.leave_end_date,
          leave_day: result.leave_days,
          leave_category: result.leave_category,
          application_status: application_status,
          reject_status: reject_status,
          reason: result.reason, // added by STHA
          comment: result.comments,
        };
      }

      if (this.state.tab == 2) {
        obj.action =
          '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toView" ><span id="view" class="hidden" >' +
          JSON.stringify(result) +
          '</span>  <i className="fa fa-cogs"></i>&nbsp;View</button>';
        if (result.application_status < 5 || result.application_status == 9) {
          obj.action +=
            '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toEdit" ><span id="edit" class="hidden" >' +
            JSON.stringify(result) +
            '</span>  <i className="fa fa-cogs"></i>&nbsp;Edit</button>';
        }

        if (result.application_status == 6 || result.application_status == 7) {
          obj.action +=
            '<button style="margin-right:10px" class="btn btn-danger btn-sm own-btn-cancel" id="toCancel" ><span id="cancel" class="hidden" >' +
            JSON.stringify(result) +
            '</span>  <i className="fa fa-cogs"></i>&nbsp;Cancel Edit</button>';
        }
      } else {
        obj.action =
          '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toView" ><span id="view" class="hidden" >' +
          JSON.stringify(result) +
          '</span>  <i className="fa fa-cogs"></i>&nbsp;View</button>';

        if (
          (result.approve_by == this.state.user_id &&
            result.application_status == 3) ||
          (result.application_status == 5 &&
            result.user_id == this.state.user_id) ||
          (result.user_id == this.state.user_id &&
            result.application_status == 9 &&
            (result.approved_date != null
              ? result.referback_date >= result.approved_date
              : result.verify_date != null
              ? result.referback_date >= result.verify_date
              : result.referback_date != null))
        ) {
          obj.action +=
            '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toEdit" ><span id="edit" class="hidden" >' +
            JSON.stringify(result) +
            '</span>  <i className="fa fa-cogs"></i>&nbsp;Edit</button>';
        }
        if (
          result.user_id == this.state.user_id &&
          result.application_status == 3 &&
          // moment(new Date()).format("YYYY-MM-DD") <=
          //   moment(getFirstDayOfNextMonth(result.leave_end_date)).format(
          //     "YYYY-MM-DD"
          //   )
          moment(new Date()).format("YYYY-MM-DD") <=
            moment(getFirstDayOfNextTwoMonth(result.leave_end_date)).format(
              "YYYY-MM-DD"
            ) // Added by SHTA for Leave Cancel btn appear after two month
        ) {
          obj.action +=
            '<button style="margin-right:10px" class="btn btn-danger btn-sm own-btn-cancel" id="toCancel" ><span id="cancel" class="hidden" >' +
            JSON.stringify(result) +
            '</span>  <i className="fa fa-cogs"></i>&nbsp;Cancel Request</button>';
        }
      }

      l.push(obj);
    }

    if ($.fn.dataTable.isDataTable("#dataTables-table")) {
      table = $("#dataTables-table").dataTable();
      table.fnClearTable();
      table.fnDestroy();
      $("#dataTables-table").empty();
    }

    var column = [];
    if (this.state.tab == 2) {
      column = [
        { title: "No", data: "no" },
        { title: "Name", data: "name" },
        { title: "Employee Id", data: "employee_id" },
        { title: "Designation", data: "designations" }, // Added by STHA
        { title: "Department", data: "deptname" }, // Added by STHA
        { title: "Branch", data: "location_master_name" }, // Added by STHA
        { title: "State ", data: "state_name" }, // Added by STHA
        { title: "Start Date", data: "start_date" },
        { title: "End Date", data: "end_date" },
        { title: "Leave Day", data: "leave_day" },
        { title: "Leave Category", data: "leave_category" },
        { title: "status", data: "application_status" },
        { title: "cancel status", data: "reject_status" },
        { title: "Reason", data: "reason" }, // Added by STHA
        { title: "Comment", data: "comment" },
      ];
    } else {
      column = [
        { title: "No", data: "no" },
        { title: "Name", data: "name" },
        { title: "Employee Id", data: "employee_id" },
        { title: "Start Date", data: "start_date" },
        { title: "End Date", data: "end_date" },
        { title: "Leave Day", data: "leave_day" },
        { title: "Leave Category", data: "leave_category" },
        { title: "status", data: "application_status" },
        { title: "cancel status", data: "reject_status" },
        { title: "Reason", data: "reason" }, // Added by STHA
        { title: "Comment", data: "comment" },
      ];
    }

    if (has_action) {
      column.push({ title: "Action", data: "action" });
    }

    table = $("#dataTables-table").DataTable({
      pageLength: 50,
      autofill: true,
      bLengthChange: false,
      bInfo: false,
      responsive: true,
      paging: true,
      buttons: true,
      dom: "Bfrtip",
      buttons: ["copy", "csv", "excel", "pdf"],
      data: l,
      columns: column,
    });
  };

  render() {
    // if (this.state.loading === true) {
    //     return <div style={{ display: 'flex', justifyContent: 'center' }}><h2>Loading...</h2></div>
    // } else {
    return (
      <div>
        <div className="row border-bottom white-bg dashboard-header">
          <div className="row">
            {this.state.tab == 0 ? (
              <>
                <div className="col-md-3">
                  <div>
                    <label className="col-sm-12">Select Year</label>
                  </div>
                  <div className="col-md-10">
                    <DatePicker
                      dateFormat="YYYY"
                      // dateFormat="DD/MM/YYYY"
                      value={moment(this.state.year).format("YYYY")}
                      onChange={this.handleYear}
                      selected={moment(this.state.year).format("YYYY")}
                      timeFormat={false}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="col-md-10 margin-top-20">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={this.handleMyLeave.bind(this)}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
            {this.state.tab == 2 ? (
              <>
                {/* <div className="col-md-3">
                  <div>
                    <label className="col-sm-12">Select Year</label>
                  </div>
                  <div className="col-md-10">
                    <DatePicker
                      dateFormat="YYYY"
                      // dateFormat="DD/MM/YYYY"
                      value={moment(this.state.year).format("YYYY")}
                      onChange={this.handleYear}
                      selected={moment(this.state.year).format("YYYY")}
                      timeFormat={false}
                    />
                  </div>
                </div> */}

                <div className="col-md-3">
                  <div>
                    <label className="col-sm-12">Start Date</label>
                  </div>
                  <div className="col-md-10">
                    <DatePicker
                      dateFormat="DD/MM/YYYY"
                      value={this.state.start_date}
                      onChange={this.handleStartDate}
                      timeFormat={false}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div>
                    <label className="col-sm-12">End Date</label>
                  </div>
                  <div className="col-md-10">
                    <DatePicker
                      dateFormat="DD/MM/YYYY"
                      value={this.state.end_date}
                      onChange={this.handleEndDate}
                      timeFormat={false}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div>
                    <label className="col-sm-12">Leave Category</label>
                  </div>
                  <div className="col-md-10">
                    <Select
                      options={this.state.leaveCategory}
                      value={this.state.selected_category}
                      onChange={this.handlecategory}
                      className="react-select-container checkValidate"
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div>
                    <label className="col-sm-12">Leave Status</label>
                  </div>
                  <div className="col-md-10">
                    <Select
                      options={this.state.statusList}
                      value={this.state.selected_status}
                      onChange={this.handlestatus}
                      className="react-select-container checkValidate"
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
                {/* Added by STHA  */}
                <div className="col-md-3">
                  <div>
                    <label className="col-sm-12">Position</label>
                  </div>
                  <div className="col-md-10">
                    <Select
                      options={this.state.designationList}
                      value={this.state.selected_position}
                      onChange={this.handlePosition}
                      className="react-select-container checkValidate"
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div>
                    <label className="col-sm-12">Department</label>
                  </div>
                  <div className="col-md-10">
                    <Select
                      options={this.state.departmentlist}
                      value={this.state.selected_department}
                      onChange={this.handleDepartment}
                      className="react-select-container checkValidate"
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div>
                    <label className="col-sm-12">Branch</label>
                  </div>
                  <div className="col-md-10">
                    <Select
                      options={this.state.branchlist}
                      value={this.state.selected_branch}
                      onChange={this.handleBranch}
                      className="react-select-container checkValidate"
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div>
                    <label className="col-sm-12">Region</label>
                  </div>
                  <div className="col-md-10">
                    <Select
                      options={this.state.regionList}
                      value={this.state.selected_region}
                      onChange={this.handleRegion}
                      className="react-select-container checkValidate"
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
                {/* Added by STHA  */}
                <div className="col-md-3">
                  <div className="col-md-10 margin-top-20">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={this.handleAllLeave.bind(this)}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </div>

        {/* {this.state.loading ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <h2>Loading...</h2>
          </div>
        ) : (
          
        )} */}

        {this.state.loading && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <h2>Loading...</h2>
          </div>
        )}

        {!this.state.loading && (
          <div className="row container mt20">
            <table
              width="99%"
              className="table table-striped table-bordered table-hover nowrap dt-responsive"
              id="dataTables-table"
            />
          </div>
        )}
      </div>
    );
  }
  // }
}
